export default {
  methods: {
    loadImage(url) {
      return new Promise((resolve) => {
        if (!url) return resolve(false)
        const img = new Image()
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false)
        img.src = url
      })
    },
    async resolveImage(candidate, fallback) {
      if (candidate && candidate.length) {
        const ok = await this.loadImage(candidate)
        return { src: ok ? candidate : fallback, exists: ok }
      }
      return { src: fallback, exists: false }
    },
  },
}
